<template>
   <div class="gens-universes">
       <div class="gens-detail">
           <div class="detail-content">
               <div class="post_image">
                    <img class="post_image_img" src="../../assets/images/gensunicerse/181221-feature-talent.jpg"/>
               </div>
               <div class="post_text">
                   <div class="post_tip">基因如何影响天赋潜能？</div>
                   <div class="post_info">Posted at 09:00h in 天赋基因</div>
                    <div class="post_tip_1" style="margin-top:0px !important;">
                       检测报告中判断孩子在相关方面天赋：较差、一般、较好和卓越的依据是什么？
                    </div>
                    <div class="post_wrapper_1">
                        我们从国际学术期刊中，寻找相关的全基因组关联分析研究（Genome-wide association study，GWAS）。按照人种相关性，研究科学性，以及文献权威性等筛选最合适的基因位点。并建立以亚洲人为本的基因位点资料库，检测后分析您的基因型。
                    </div>
                    <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/181221-gwas.jpg"/>
                        <div class="bottom_tip">天赋基因检测报告中判断孩子相关天赋的依据是什么？</div>
                    </div>
                    <div class="post_wrapper_tip">绘画天赋 – CNGB3</div>
                    <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/181221-cngb3-drawing.jpg"/>
                        <div class="bottom_tip">天赋基因检测报告中判断孩子相关天赋的依据是什么？</div>
                    </div>
                    <div class="post_wrapper_tip">爆发力 – ACTN3</div>
                    <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/181221-actn3-sport.jpg"/>
                        <div class="bottom_tip">天赋基因检测报告中判断孩子相关天赋的依据是什么？</div>
                    </div>
                     <div class="post_wrapper_tip">操作智商 – SNAP-25</div>
                    <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/181221-snap25-iq.jpg"/>
                        <div class="bottom_tip">天赋基因检测报告中判断孩子相关天赋的依据是什么？</div>
                    </div>
                    <div class="post_wrapper_tip">叶酸水平 – MTHFR</div>
                    <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/181221-mthfr-nutrition.jpg"/>
                        <div class="bottom_tip">天赋基因检测报告中判断孩子相关天赋的依据是什么？</div>
                    </div>
                    <div class="post_wrapper_tip">内向型性格 – BDNF</div>
                    <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/181221-bdnf-eq.jpg"/>
                        <div class="bottom_tip">天赋基因检测报告中判断孩子相关天赋的依据是什么？</div>
                    </div>
                     
               </div>
           </div>
           <div class="detail-list-menu">
               <div class="list-menu-item">
                   	<h5>最新資訊</h5>		
                       <ul>
							<li>
					            <a href="#/gensone">無免疫力孕婦的患麻疹 最嚴重可流產</a>
							</li>
							<li>
					            <a href="#/genstwo">無入侵性抽血驗癌症 適宜年老病人</a>
							</li>
							<li>
					            <a href="#/gensthree">最易被忽略的一種過敏食物</a>
							</li>
							<li>
					            <a href="#/gensfour">樂觀女性生仔機會較大</a>
						    </li>
							<li>
					            <a href="#/gensfive">雙胞胎兒竟然是同母異父</a>
							</li>
					</ul>
               </div>
               <div class="list-menu-item">
                   <h5>分類</h5>		
                   <ul>
				       <li>
                           <a href="#/gensuniversecate?categoryName=传染病&isCategory=1">傳染病</a> (2)
                       </li>
                       <li >
                           <a href="#/gensuniversecate?categoryName=天赋基因&isCategory=1">天賦基因</a> (1)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=无创产前检测&isCategory=1">無創產前檢測</a> (2)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=生育健康&isCategory=1">生育健康</a> (4)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=癌症&isCategory=1">癌症</a> (4)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=致敏原&isCategory=1">致敏原</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=亲子鉴定&isCategory=1">親子鑑定</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=遗传病&isCategory=1">遺傳病</a> (1)
                        </li>
                    </ul>
               </div>
           </div>
       </div>
   </div>
</template>
<script>
export default {
    data(){
        return{
          
        }
    },
    mounted(){

    },
    methods:{

    }
}
</script>


<style lang="scss" scoped>
.gens-universes{
    width: 100%;
    position: relative;
    margin-top:1rem;
    text-align: center;
    margin-bottom:25px;
    
    font-family: 'Microsoft JhengHei',sans-serif !important;
      margin-top:25px;
    .gens-detail{
        text-align: left;
        margin-top:10px;
        width:57.5%;
        margin:auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .detail-content{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            width:66.66%;
            .post_image{
                position: relative;
                width: 100%;
                display: block;
                .post_image_img{
                   max-width: 100%;
                   height: auto; 
                }
            }
            .post_text{
                .post_tip{
                    margin-top:35px;
                    color: #368da7;
                    font-size: 28px;
                    font-style: normal;
                    font-weight: 600;
                    letter-spacing: 0;
                    text-transform: none;
                }
                .post_info{
                    display: inline-block;
                    width: 100%;
                    margin: 0 0 18px;
                    color: #bebebe;
                    font-weight: 500;
                    line-height: 27px;
                    font-size: 16px;
    
                }
                .post_wrapper{
                    
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    display: block;
                }
                .post_tip_1{
                    margin-top:35px;
                    border-color: #368da7;
                    background-color: #e9faff;
                    padding: 14px 14px 14px 10px;
                    border-left: 4px solid #368da7;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;

                }
                .post_wrapper_1{
                    margin-top:15px;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                }
                .post_wrapper_1 a{
                    color:#368da7;
                    text-decoration: none;
                }
                .post_wrapper_1 a:hover{
                    color:#9bd9dd;;
                    text-decoration: none;
                }
                .post_wrapper_tip{
                    margin-top:35px;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 600;
                    text-transform: none;
                    color: #368da7;
                }
                .post_wrapper_img{
                    margin-top:35px;
                    text-align: center;
                    img{
                        vertical-align: middle;
                        height: auto;
                        max-width: 100%;
                    }
                    .bottom_tip{
                        margin-top: .2em;
                       font-size: .8em;
                    }
                }
            }
            
        }
        .detail-list-menu{
            width: 33.33%;
            display: flex;
            padding-left:40px;
            justify-content: left;
            align-items: flex-start;
            flex-direction: column; 
            align-self: flex-start;
            .list-menu-item{

                width:100%;
                background-color: #f3f3f3!important;
                padding: 14px!important;
                box-shadow: 4px 4px 5px #cfcfcf;
                margin: 0 0 42px;
            }
            .list-menu-item h5{
                 color: #368da7!important;
                 font-size: 18px;
                font-style: normal;
                font-weight: 600;
                text-transform: none;
            }
            .list-menu-item ul{
                list-style: none;
                padding: 0;
                background: 0 0;
                border: 0;
                margin: 0;
                padding: 0;
                vertical-align: baseline;
                outline: 0;
                color: #3b3b3b;
            }
            .list-menu-item li{
                line-height: 27px;
                letter-spacing: .07em!important;
                font-size: 14px;
                padding: 5px 0;
                margin: 0;
                vertical-align: baseline;
            }
            .list-menu-item a{
                
                text-decoration: none;
                color:  #303030 !important;
                font-weight: 400;
            }
            .list-menu-item a:hover{
                color: #9bd9dd !important;
                font-weight: 400;
            }
        }
    }

           
}
</style>


// WEBPACK FOOTER //
// src/view/gensuniversedetail/gensnine.vue